import './Confirm.scss'
import React from 'react'
import _ from 'lodash'
import Button from '../Button'
import Popconfirm from '../../Popconfirm'

const ANT_BUTTON_PROPS = [
  'className', 'ghost', 'href', 'htmlType', 'icon', 'loading',
  'disabled', 'shape', 'size', 'target', 'type', 'onClick'
]

const Confirm = ({ children, ...props }) => {
  const buttonProps = _.pick(props, ANT_BUTTON_PROPS)
  const popconfirmProps = _.omit(props, ANT_BUTTON_PROPS)

  return (
    <Popconfirm placement='bottomLeft' {...popconfirmProps}>
      <Button {...buttonProps}>{children}</Button>
    </Popconfirm>
  )
}
export default Confirm
